export default {
  init() {
    // JavaScript to be fired on the about us page
    jQuery(document).ready(() => {

      let upd_cart_btn = jQuery("input[name='update_cart']");
      upd_cart_btn.hide();

      jQuery(document).on("change", ".cart-form .qty", function(){
        let upd_cart_btn = jQuery("input[name='update_cart']");
        upd_cart_btn.trigger("click");
        upd_cart_btn.hide();
      });

      if(jQuery(".wc-giftwrap").length > 0) {
        jQuery('.wc_giftwrap_notes').attr('placeholder', PomeloVar.giftwrap); // eslint-disable-line
      }

      jQuery(document).on("change", "#getEmballagage", function() {
        if(jQuery(".wc-giftwrap").length > 0) {
          jQuery('.wc_giftwrap_notes').attr('placeholder', PomeloVar.giftwrap); // eslint-disable-line
          if( jQuery(this).prop('checked') == true ) {
            jQuery('.wc-giftwrap').slideDown();
          } else {
            jQuery('.wc-giftwrap').slideUp();
          }
        }
      });

      if(jQuery("#dgfw-gifts-carousel").length > 0) {
        jQuery("#dgfw-gifts-carousel").detach().appendTo('#cadeau-carroussel');
          jQuery('.dgfw-add-gift-button').attr('class','btn btn-oceopin-8 d-flex mr-auto ml-auto add_to_cart_button single_add_to_cart_button button alt col-auto text-uppercase').removeAttr('disabled').on('click', function(e) {
            e.preventDefault();
            var data = {
              product_id: jQuery(this).data('gift'),
            };
            jQuery('#modalCC').modal('hide');
            jQuery.post(window.PomeloVar.siteurl + '?wc-ajax=add_to_cart' , data, function(response) {
              if(response != 0) {
                jQuery(document).trigger('wc_update_cart');
              } else {
                jQuery('#modalCC').modal('show');
              }
            });
        });
        jQuery('#modalCC').modal('show');
        jQuery('.dgfw-gift').on('click', function(e) {
          e.preventDefault();
          return false;
        });
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce-cart.js